import { render } from "./Test.vue?vue&type=template&id=9a4826c8&scoped=true"
import script from "./Test.vue?vue&type=script&lang=js"
export * from "./Test.vue?vue&type=script&lang=js"

import "./Test.vue?vue&type=style&index=0&id=9a4826c8&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-9a4826c8"

export default script